import axios from "axios";
import UserService from "./UserService";

const HttpMethods = {
  GET: "GET",
  POST: "POST",
  DELETE: "DELETE",
};

const _axios = axios.create();
const configure = () => {
  _axios.interceptors.request.use((config) => {
    // Special handling for file uploads
    const isFileUpload =
      config.url &&
      config.url.includes("upload") &&
      config.headers &&
      config.headers["content-type"] &&
      (config.headers["content-type"].includes("multipart/form-data") ||
        config.headers["content-type"].includes("application/octet-stream"));

    // Check if this is a binary upload (application/octet-stream content type)
    const isBinaryUpload =
      config.headers &&
      config.headers["content-type"] &&
      config.headers["content-type"].includes("application/octet-stream");

    if (isFileUpload || isBinaryUpload) {
      // For file uploads, preserve configuration without modification
      // except for required authorization headers
      if (UserService.isLoggedIn()) {
        config.headers.Authorization = `Bearer ${UserService.getToken()}`;

        const chosenEmployerId = sessionStorage.getItem("chosenEmployerId");
        if (chosenEmployerId) {
          config.headers["X-Chosen-Employer"] = chosenEmployerId;
        } else {
          delete config.headers["X-Chosen-Employer"];
        }
      }
      return Promise.resolve(config);
    } else if (UserService.isLoggedIn()) {
      // Normal handling for non-file upload requests
      const cb = () => {
        config.headers.Authorization = `Bearer ${UserService.getToken()}`;
        // Always set or remove chosen organization header
        const chosenEmployerId = sessionStorage.getItem("chosenEmployerId");
        if (chosenEmployerId) {
          config.headers["X-Chosen-Employer"] = chosenEmployerId;
        } else {
          delete config.headers["X-Chosen-Employer"];
        }

        return Promise.resolve(config);
      };
      return UserService.updateToken(cb);
    }
  });
};

const getAxiosClient = () => _axios;

const HttpService = {
  HttpMethods,
  configure,
  getAxiosClient,
};

export default HttpService;
